import React, { useEffect, useState } from "react";

//
import { Row, Col, Card, Button } from "react-bootstrap";

//
import { getCategories, getEvents } from "../../redux/features/coins/actions";

//
import PageHeader from "../../components/general/PageHeader";
import BoxLoading from "../../components/general/BoxLoading";
import FilterDropdown from "../../components/general/FilterDropdown";
import NothingToShow from "../../components/general/NothingToShow";

function Events() {
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(10);
  //
  const [events, setEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({});

  /**
   * Get Categories
   */
  const get_categories = async () => {
    // start loading
    setLoading(true);

    // request
    await getCategories().then((res) => {
      if (res) {
        setCategories(res.event);
        setSelectedCategory(res.event[0]);
      }
    });

    // stop loading
    setLoading(false);
  };

  /**
   * Get Coin Evants
   * if active filter is selected
   */
  const get_coin_events = async () => {
    if (selectedCategory.value) {
      // start loading
      setLoading(true);

      // set variable
      let category = selectedCategory.value;

      // request
      await getEvents(category).then((res) => {
        if (res) {
          setEvents(res);
        }
      });

      setLoading(false);
    }
  };

  useEffect(() => {
    get_categories();

    // eslint-disable-next-line
  }, []);

  /**
   * Get coin events every time active filter change
   */
  useEffect(() => {
    get_coin_events();
  }, [selectedCategory]);

  return (
    <div id="events" className="position-relative">
      {/* Start Header */}
      <PageHeader title="Coins Events" subject="See upcoming events">
        <FilterDropdown
          filters={categories}
          activeFilter={selectedCategory}
          action={(item) => setSelectedCategory(item)}
          title="Type"
        />
      </PageHeader>
      {/* End Header */}

      {loading && <BoxLoading />}

      {/* Start Page Content */}
      {events.length ? (
        <>
          <Row>
            {events.slice(0, limit).map((item, index) => (
              <Col md={6} className="gutter-b" key={index}>
                <Card className="item">
                  <Card.Body>
                    <Row>
                      <Col lg={10} xxl={8}>
                        <h5 className="truncate">{item.title}</h5>

                        <p>{item.content}</p>

                        <a href={item.originalSource} target="_blank">
                          <Button variant="info">See Resources</Button>
                        </a>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {limit < events.length && (
            <Button
              variant="white"
              size="lg"
              className="d-block m-auto"
              onClick={() => setLimit(limit + 6)}
            >
              See other events
            </Button>
          )}
        </>
      ) : (
        <Card>
          <NothingToShow text={loading ? "Loading..." : "No event to show"} />
        </Card>
      )}
      {/* {End Page Content} */}
    </div>
  );
}

export default Events;
